module.exports = __webpack_public_path__ + "media/bangkok/bangkok white-dfd969a1.jpg";